import { z } from 'zod';

export const enqueueImgJobsResponseSchema = z.object({
  accepted: z.boolean(),
  enqueued: z.number(),
  duplicates: z.number(),
});

export type IEnqueueImgJobsResponse = z.infer<typeof enqueueImgJobsResponseSchema>;
